import { homeComingBoxesService } from '@/services/home-boxes.service';
import { HomeBoxesAdmin } from './HomeBoxesAdmin';

export const HomeComingBoxes = () => (
  <HomeBoxesAdmin pageTitle="Gestion des boxes prochainement arrivé" boxesService={homeComingBoxesService} />
);
